import EmptyCatalogTable from 'assets/images/SllrEmptyCatalogTable.png';
import EmptyCatalogTableAR from 'assets/images/SllrEmptyCatalogTableAr.png';
import EmptyCatalogTableMobile from 'assets/images/EmptyCatalogTableMobile.png';
import EmptyCatalogTableMobileAR from 'assets/images/EmptyCatalogTableMobileAR.png';
import EmptyCatalogTableSaudi from 'assets/images/SllrEmptyCatalogTableSaudi.png';
import EmptyCatalogTableSaudiAR from 'assets/images/SllrEmptyCatalogTableSaudiAR.png';
import EmptyCatalogTableSaudiMobile from 'assets/images/EmptyCatalogTableMobileSaudi.png';
import EmptyCatalogTableSaudiMobileAR from 'assets/images/EmptyCatalogTableMobileSaudiAR.png';
import AdjacentCard1 from 'assets/images/SllrAdjacentCard1.png';
import { ReactComponent as AdjacentCard2 } from 'assets/images/SllrAdjacentCard2.svg';
import AdjacentCard1Saudi from 'assets/images/SllrAdjacentCard1Saudi.png';
import { ReactComponent as AdjacentCard2Saudi } from 'assets/images/SllrAdjacentCard2Saudi.svg';
import EmptyCard1 from 'assets/images/SllrEmptyCard1.png';
import EmptyCard1Saudi from 'assets/images/SllrEmptyCard1Saudi.png';

export const IMAGES_LIST = {
  EG: {
    catalog_table: EmptyCatalogTable,
    catalog_tableAR: EmptyCatalogTableAR,
    catalog_table_mobile: EmptyCatalogTableMobile,
    catalog_tableAR_mobile: EmptyCatalogTableMobileAR,
    sllr_store_table: AdjacentCard1,
    sllr_store_analytics: <AdjacentCard2 />,
    empty_card1: EmptyCard1
  },
  SA: {
    catalog_table: EmptyCatalogTableSaudi,
    catalog_tableAR: EmptyCatalogTableSaudiAR,
    catalog_table_mobile: EmptyCatalogTableSaudiMobile,
    catalog_tableAR_mobile: EmptyCatalogTableSaudiMobileAR,
    sllr_store_table: AdjacentCard1Saudi,
    sllr_store_analytics: <AdjacentCard2Saudi />,
    empty_card1: EmptyCard1Saudi
  }
};
